export class DriverModel {
    id: number;
    assignedStates: [];
    assignedVehicle: Array<any>;
    documentExpiry: [];
    email: string | null | '';
    employeeCode: string | null | '';
    firstName: string | null | '';
    fullName: string | null | '';
    guid: string | null | '';
    lastName: string | null | '';
    phoneNumber: string | null | '';
    profilePicture: string | null | '';
    stateId: number;
    stateName: string | null | '';
    stateAbbr: string | null | '';
    statusId: number;
    employeeTypeId: number;
    employeeTypeServices: Array<any>;
    roles: Array<any>;
    availabilityId: number;
    inductedCustomerBranchIds: number[];
    inductedCustomerBranchNames: string[];
    accountTypes: Array<number>;
    initialName: string;
    badgeColor: string;
    dateCreated: string;
    /** A supplied driver's supplier (suppliers.id) - 0 for a regular driver. */
    supplierId: number;

    constructor () {
        this.id = 0;
        this.assignedStates = [];
        this.assignedVehicle = [];
        this.documentExpiry = [];
        this.email = null;
        this.employeeCode = null;
        this.firstName = null;
        this.fullName = null;
        this.guid = null;
        this.lastName = null;
        this.phoneNumber = null;
        this.profilePicture = null;
        this.stateId = 0;
        this.stateName = null;
        this.stateAbbr = null;
        this.statusId = 0;
        this.employeeTypeId = 0;
        this.employeeTypeServices = [];
        this.roles = [];
        this.availabilityId = 0;
        this.inductedCustomerBranchIds = [];
        this.inductedCustomerBranchNames = [];
        this.accountTypes = [];
        this.initialName = '';
        this.badgeColor = '';
        this.dateCreated = '';
        this.supplierId = 0;
    }

    public static fromJson (json: any): DriverModel {
        const driver = new DriverModel;
        const getInitialName = (value: string): string => {
        if (!value?.trim()) return "";

        const words = value.trim().split(/\s+/);
        if (words.length === 1) {
            return words[0].charAt(0).toUpperCase();
        }

        const firstInitial = words[0].charAt(0);
        const lastInitial = words[words.length - 1].charAt(0);

        return (firstInitial + lastInitial).toUpperCase();
        };
        const fullName = `${json.first_name} ${json.last_name}`;
        Object.assign(driver, {
            id: json.id,
            assignedStates: json.assigned_states,
            assignedVehicle: json.vehicle || json.vehicle_drive,
            documentExpiry: json.documents_expiry_date,
            email: json.email,
            employeeCode: json.employee_code,
            firstName: json.first_name,
            fullName,
            guid: json.guid,
            lastName: json.last_name,
            phoneNumber: json.contact_number,
            profilePicture: json.profile_picture_thumbnail ? json.profile_picture_thumbnail : (json.profile_picture ?? null),
            stateId: json.state_id,
            stateAbbr: '',
            stateName: '',
            statusId: json.status_id,
            employeeTypeId: json.employee_type,
            employeeTypeServices: json.employee_type_services,
            roles: json.driver_roles || json.roles ,
            availabilityId: json.availability_id,
            inductedCustomerBranchIds: (json.inducted_customer_branches || []).map((cb:any) => {
                return cb.id
            }),
            accountTypes: json.account_type_ids,
            initialName: getInitialName(fullName),
            badgeColor: randomColor(),
            dateCreated: json.date_added,
            supplierId: Number(json.supplier_id ?? 0)
        });
        return driver;
    }
}

export function randomColor () {
    const hue = Math.floor(Math.random() * 360);
    const saturation = 60 + Math.floor(Math.random() * 30);
    const lightness = 15 + Math.floor(Math.random() * 20);
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}